import { sample } from 'effector';
import {
  applyChatHexagonsEv,
  revertChatFiltersEv,
  saveChatHexagonsEv,
} from './events.js';
import {
  $activeChatHexagons,
  $chatHexagons,
  $isChatFilters,
} from './stores.js';
import zoom9 from '../../data/zoom9.json';

$isChatFilters.on(applyChatHexagonsEv, () => true).reset(revertChatFiltersEv);

$activeChatHexagons.reset(revertChatFiltersEv);

sample({
  source: $chatHexagons,
  clock: saveChatHexagonsEv,
  fn: (source, clock) => {
    return {
      ...source,
      [clock.message_index]: clock.map_data.map((item, index) => {
        const geometry = zoom9.features.find(
          (feature) => feature.id === item
        )?.geometry;

        return {
          geometry,
          id: index,
          type: 'Feature',
          properties: {},
        };
      }),
    };
  },
  target: $chatHexagons,
});
